// utils/navigationItems.ts
import { useTranslation } from '@/context/TranslationContext';
import { NavigationItem } from '@/interfaces/Navigation';
import { usePathname } from 'next/navigation';
// utils/navigationItems.ts
export const useMainNavigationItems = (): NavigationItem[] => {
  const { dictionary } = useTranslation();
  const pathname = usePathname();

  const getActiveLocale = () => {
    const segments = pathname?.split('/') || [];
    return segments[1];
  };

  const activeLocale = getActiveLocale();

  return [
    { name: dictionary.navigation.home, href: `/${activeLocale}` },
    {
      name: dictionary.navigation.talents,
      href: `/${activeLocale}/voor-talenten`,
      subItems: [
        { name: dictionary.talents.vacancies, href: `/${activeLocale}/voor-talenten/vacatures` },
        { name: dictionary.talents.it, href: `/${activeLocale}/voor-talenten/it` },
        { name: dictionary.talents.engineering, href: `/${activeLocale}/voor-talenten/engineering` },
        { name: dictionary.talents.approach, href: `/${activeLocale}/voor-talenten/onze-aanpak` },
      ],
    },
    {
      name: dictionary.navigation.clients,
      href: `/${activeLocale}/voor-opdrachtgevers`,
      subItems: [
        { name: dictionary.clients.freelance, href: `/${activeLocale}/voor-opdrachtgevers/freelance` },
        { name: dictionary.clients.permanent, href: `/${activeLocale}/voor-opdrachtgevers/werving-en-selectie` },
        { name: dictionary.clients.detavast, href: `/${activeLocale}/voor-opdrachtgevers/detavast` },
        { name: dictionary.clients.payrolling, href: `/${activeLocale}/voor-opdrachtgevers/payrolling` },
      ],
    },
    { name: dictionary.navigation.careers, href: `/${activeLocale}/werkenbij` },
    { name: dictionary.navigation.about, href: `/${activeLocale}/over-ons` },
    { name: dictionary.navigation.contact, href: `/${activeLocale}/contact` },
  ];
};
